import React from 'react';

import { MultipleSelectControlProps } from './MultipleSelectControl.interfaces';
import { MultipleSelect } from 'app/components/MultipleSelect';
import { DictionaryEntryKey } from 'app/services/dict.service';

export default function MultipleSelectControl(
  props: MultipleSelectControlProps
) {
  const handleChange = (entries: Array<DictionaryEntryKey>) => {
    if (entries.length > 100) return;

    props.input.onChange(entries);

    if (props.onValueChange) {
      props.onValueChange(entries, false, true);
    }
  };

  return <MultipleSelect {...props} handleChange={handleChange} />;
}
